$(window).scroll(function() {    
    var scroll = $(window).scrollTop();    
    if (scroll >= 48) {
        $("header").addClass("darkHeader");
    } else{
        $("header").removeClass("darkHeader");
    }
});
$(document).ready(function(){
    $(".color-related-products-wrapper ul li a").hover(function () {
        var getColorName = $(this).attr("data-color-name");
        if(typeof getColorName != "undefined" && getColorName != null && getColorName != "")
        {
            $(".color-related-products-title span").html("");
            $(".color-related-products-title span").html(getColorName);
        }
    }, function () {
        var getCurrentColorName = $(this).attr("data-current-color");
        if(typeof getCurrentColorName != "undefined" && getCurrentColorName != null && getCurrentColorName != "")
        {
            $(".color-related-products-title span").html("");
            $(".color-related-products-title span").html(getCurrentColorName);
        }
    }); 
});